import { H_REFERENCIAL_PARAMETER } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import { checkAbillitation } from 'referencial/util/ReferencialUtils'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import { back } from '@lagunovsky/redux-react-router'
import ToastrAction from 'toastr/actions/ToastrAction'
import ParameterAction from '../actions/ParameterAction'

const ParameterRouterApp = () => {
    const dispatch = useDispatch()
    const { code } = useParams()

    const {
        user,
    } = useSelector(store => ({
        user: store.UserReducer.user,
    }), shallowEqual)

    const navLinks = useMemo(() => {
        const dashboardLink = [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.parameter}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_PARAMETER,
        }].filter(l => componentHasHabilitations(l.habilitation))

        if (code === 'new') {
            return dashboardLink
        }
        return [
            ...dashboardLink,
            {
                icons: 'map',
                name: i18n.cartography,
                href: `/referencial/${REFERENCIAL_TYPE_NAME.parameter}/${code}/map`,
                habilitation: H_REFERENCIAL_PARAMETER,
            }, {
                icons: 'water',
                name: i18n.source,
                href: `/referencial/${REFERENCIAL_TYPE_NAME.parameter}/${code}/source`,
                habilitation: H_REFERENCIAL_PARAMETER,
            },
        ].filter(l => componentHasHabilitations(l.habilitation))
    }, [code])

    useEffect(() => {
        checkAbillitation(user, () => {}, () => {
            back()
            dispatch(ToastrAction.error(i18n.AccessRightDeny))
        })
    })

    useEffect(() => {
        dispatch(ParameterAction.fetchParameters())
        dispatch(ParameterAction.fetchParameter(code))
    }, [dispatch, code])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks} />
            <main>
                <div className='row no-margin padding-left-1'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default ParameterRouterApp